import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-dispo-edit-btns',
    templateUrl: './dispo-edit-btns.component.html',
    styleUrls: ['./dispo-edit-btns.component.scss'],
    standalone: true,
    imports: [TooltipModule]
})
export class DispoEditBtnsComponent implements ICellRendererAngularComp {
  params: any;
  editButtonsVisible = true;
  deleteButtonsNotVisible = false;

  constructor(public sharedService: SharedService) { }

  agInit(params: any): void {
    this.params = params;
  }
  refresh(params?: any): boolean {
    return true;
  }

  // Button functions
  editFirearmClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.editFirearm(rowData);
  }
  deleteFirearmClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.deleteFirearm(rowData);
  }
}
